// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"expandIcon_2Dam4"};